// extracted by mini-css-extract-plugin
export default {"container":"VN-z","topReviewHeading":"WN-z","criticalReview":"XN-z","favorableReview":"YN-z","vsSeparator":"ZN-z"};